module.exports = __webpack_public_path__ + "static/media/v4-shims.min.a0c6ae12.css";